import { render, staticRenderFns } from "./DrinkDetails.vue?vue&type=template&id=26f9f986&scoped=true&"
import script from "./DrinkDetails.vue?vue&type=script&lang=js&"
export * from "./DrinkDetails.vue?vue&type=script&lang=js&"
import style0 from "./DrinkDetails.vue?vue&type=style&index=0&id=26f9f986&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f9f986",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
